import React, { useContext } from 'react';
import ServiceDetail from '../ServiceDetail/ServiceDetail';
import Quality from '../../../resources/images/Quality.jpg';
import Purity from '../../../resources/images/Purity.jpg';
import Safety from '../../../resources/images/Safety.jpg';
import { LanguageContext } from '../../../Contexts/LanguageContext';

const serviceData = [
    {
        title: "We Love Quality",
        titleBangla: "আমরা মানের উৎকর্ষতা নিশ্চিত করি",
        description: "We maintain the best quality ingredients to ensure the premium quality",
        descriptionBangla: "প্রিমিয়াম গুণমান নিশ্চিত করার জন্য আমরা সেরা মানের উপাদান ব্যবহার করি",
        img: Quality
    },
    {
        title: "We Ensure Purity",
        titleBangla: "আমরা বিশুদ্ধতাকে নিশ্চিত করি",
        description: "We are providing pure natural products for you",
        descriptionBangla: "আমরা আপনার জন্য বিশুদ্ধ প্রাকৃতিক পণ্য সরবরাহ করছি",
        img: Purity
    },
    {
        title: "We Ensure Safety",
        titleBangla: "আমরা আপনার সুরক্ষা নিশ্চিত করি",
        description: "We provide the premium quality products for long term safety",
        descriptionBangla: "আমরা প্রিমিয়াম মানের পণ্য উৎপাদন করি যা দীর্ঘ মেয়াদী নিরাপত্তা নিশ্চিত করে",
        img: Safety
    }
]

const OurServices = () => {
    const [isBangla, setIsBangla] = useContext(LanguageContext)
    return (
        <section id='Our-Services' className='my-5'>
            <div className="container">
                <h1 className='text-center my-5 pt-5' style={{ fontWeight: 600 }}>{isBangla ? <span>আমাদের <span style={{ color: "#4871FF" }}>সেবাসমূহ</span></span> : <span><span style={{ color: "#4871FF" }}>Services</span> We Provide</span>}</h1>
                <div className="row">
                    {
                        serviceData.map(service => <ServiceDetail service={service} key={service.title} />)
                    }
                </div>
            </div>
        </section>
    );
};

export default OurServices;
